/**
* 数据报表 日报统计
*/
<template>
    <div class="census">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>数据报表</el-breadcrumb-item>
            <el-breadcrumb-item>日报统计</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="应用">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.app_name"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,1)"  @change="handleChange1" placeholder="应用">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.channel_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,2)"  @change="handleChange2" placeholder="渠道">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="销售人员">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.salesman_name"
                    :fetch-suggestions="paramValueSearch3" @select="handleSelect($event,3)"  @change="handleChange3" placeholder="销售人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道人员">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.channeler_name"
                    :fetch-suggestions="paramValueSearch4" @select="handleSelect($event,4)"  @change="handleChange4" placeholder="渠道人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="运营人员">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.operationsman_name"
                    :fetch-suggestions="paramValueSearch5" @select="handleSelect($event,5)"  @change="handleChange5" placeholder="运营人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="应用结算依据">
                <el-select size="small" v-model="formInline.app_settlement_dep" placeholder="请选择" class="userRole">
                    <el-option label="全部" :value="-1"></el-option>
                    <el-option label="渠道激活" :value="0"></el-option>
                    <el-option label="应用回调" :value="1"></el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="统计开始日期">
                <el-date-picker size="small" v-model="formInline.statis_begindate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入统计开始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="统计截至日期">
                <el-date-picker size="small" v-model="formInline.statis_enddate" value-format="yyyy-MM-dd" type="date"
                    placeholder="输入统计截至日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'appinfo.list'">搜索
                </el-button>
                <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
                <el-button size="small" type="default" icon="el-icon-download" @click="chooseExport">导出</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="statis_date" label="统计日期" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_id" label="应用ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_name" label="应用名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_id" label="渠道ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_name" label="渠道名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_settlement_dep" label="应用结算依据" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_click_qty" label="渠道点击数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_activate_qty" label="渠道激活数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_callback_qty" label="应用回调数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_settlement_qty" label="应用结算数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_settlement_qty" label="渠道结算数" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_price" label="应用单价" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_price" label="渠道单价" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_income" label="应用收入" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_cost" label="渠道成本" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="profit" label="利润" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="salesman_name" label="销售人员" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channeler_name" label="渠道人员" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="operationsman_name" label="运营人员" width="120">
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
    let change = [];
    import {
        dailyreportList,
        appList,
        channelList
    } from '../../api/basisMG'
    import { userList } from '../../api/userMG'
    import Pagination from '../../components/Pagination'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                formInline: {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    salesman_id: '',
                    salesman_name: '',
                    channeler_id: '',
                    channeler_name: '',
                    operationsman_id: '',
                    operationsman_name: '',
                    app_settlement_dep: -1,
                    statis_begindate: '',
                    statis_enddate: '',
                    orderby: ''
                },
                listData: [], //应用数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 10
                },
                appList:[],
                channelList:[],
                salesmanlist: [], //营销人员列表
                channelerlist:[],
                operationsmanlist: [], //运营人员列表
                time:''
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            /*this.getTime();
            if (!this.formInline.statis_begindate) {
                this.formInline.statis_begindate = this.time;
            }
            var formInline = localStorage.getItem('advert')
            if (formInline) {
                this.formInline = JSON.parse(formInline)
            }
            this.getdata(this.formInline)*/
            this.reset();
            this.getappList();
            this.getchannelList();
            this.getsalesmanlist();
            this.getchannelerlist();
            this.getoperationsmanlist()
            
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取列表
            getdata(parameter) {
                var that = this;
                that.loading = true;
                dailyreportList(parameter)
                    .then(res => {
                        that.loading = false
                        if (res.statusCode == 200) {
                            that.listData = res.data.datas
                            // 分页赋值
                            that.pageparm.currentPage = res.data.pageindex
                            that.pageparm.pageSize = res.data.pagesize
                            that.pageparm.total = res.data.rowscount
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取应用列表
            getappList() {
                var that = this;
                var data = { 'pagesize': '0' }
                appList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.appList.push({
                                    value: item.app_name,
                                    id: item.app_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取渠道列表
            getchannelList() {
                var that = this;
                var data = { 'pagesize': '0' }
                channelList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.channelList.push({
                                    value: item.channel_name,
                                    id: item.channel_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取销售人员列表
            getsalesmanlist() {
                var that = this;
                var data = {
                    'pagesize': '0',
                    'role_name': '销售'
                }
                this.salesmanlist = []
                userList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.salesmanlist.push({
                                    value: item.user_name,
                                    id: item.user_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取渠道人员列表
            getchannelerlist() {
                var that = this;
                var data = {
                    'pagesize': '0',
                    'role_name': '渠道'
                }
                this.channelerlist = []
                userList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.channelerlist.push({
                                    value: item.user_name,
                                    id: item.user_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取运营人员列表
            getoperationsmanlist() {
                var that = this;
                var data = {
                    'pagesize': '0',
                    'role_name': '运营'
                }
                this.operationsmanlist = []
                userList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.operationsmanlist.push({
                                    value: item.user_name,
                                    id: item.user_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageindex = parm.currentPage
                this.formInline.pagesize = parm.pageSize
                localStorage.setItem('census', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 排序
            sortChange(column, prop, order) {
                var order = '';
                if (column.order == 'ascending') {
                    order = 'asc'
                } else if (column.order == 'descending') {
                    order = 'desc'
                }
                if (order) {
                    this.formInline.orderby = column.prop + ' ' + order
                    this.search();
                }
            },
            // 搜索事件
            search() {
                this.formInline.pageindex = 1;
                localStorage.setItem('census', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 重置
            reset() {
                this.formInline = {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    salesman_id: '',
                    salesman_name: '',
                    channeler_id: '',
                    channeler_name: '',
                    operationsman_id: '',
                    operationsman_name: '',
                    app_settlement_dep: '',
                    statis_begindate: '',
                    statis_enddate: '',
                    orderby: ''
                }
                this.getTime();
                this.formInline.statis_begindate = this.time;
                // 重置清掉本地搜索缓存
                localStorage.removeItem('advert')
                this.getdata(this.formInline)
            },
            // 自定义输入下拉框
            paramValueSearch1(queryString, cb) {
                var appList = this.appList;
                var results = queryString ? appList.filter(this.createFilter(queryString)) : appList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch2(queryString, cb) {
                var channelList = this.channelList;
                var results = queryString ? channelList.filter(this.createFilter(queryString)) : channelList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch3(queryString, cb) {
                var salesmanlist = this.salesmanlist;
                var results = queryString ? salesmanlist.filter(this.createFilter(queryString)) : salesmanlist;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch4(queryString, cb) {
                var channelerlist = this.channelerlist;
                var results = queryString ? channelerlist.filter(this.createFilter(queryString)) : channelerlist;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch5(queryString, cb) {
                var operationsmanlist = this.operationsmanlist;
                var results = queryString ? operationsmanlist.filter(this.createFilter(queryString)) : operationsmanlist;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return restaurant.value.toUpperCase().match(queryString.toUpperCase()) //模糊查询
                    // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 精准查询
                };
            },
            handleSelect(item,index){
                if(index == 1){
                    this.formInline.app_id = item.id;
                    this.formInline.app_name = item.value;
                }else if(index == 2){
                    this.formInline.channel_id = item.id;
                    this.formInline.channel_name = item.value;
                }else if(index == 3){
                    this.formInline.salesman_id = item.id;
                    this.formInline.salesman_name = item.value;
                }else if(index == 4){
                    this.formInline.channeler_id = item.id;
                    this.formInline.channeler_name = item.value;
                }else if(index == 5){
                    this.formInline.operationsman_id = item.id;
                    this.formInline.operationsman_name = item.value;
                }
            },
            handleChange1(val){
                if(val == ''){
                    this.formInline.app_id = '';
                    this.formInline.app_name = '';
                    localStorage.setItem('census', JSON.stringify(this.formInline))
                }
            },
            handleChange2(val){
                if(val == ''){
                    this.formInline.channel_id = '';
                    this.formInline.channel_name = '';
                    localStorage.setItem('census', JSON.stringify(this.formInline))
                }
            },
            handleChange3(val){
                if(val == ''){
                    this.formInline.salesman_id = '';
                    this.formInline.salesman_name = '';
                    localStorage.setItem('census', JSON.stringify(this.formInline))
                }
            },
            handleChange4(val){
                if(val == ''){
                    this.formInline.channeler_id = '';
                    this.formInline.channeler_name = '';
                    localStorage.setItem('census', JSON.stringify(this.formInline))
                }
            },
            handleChange5(val){
                if(val == ''){
                    this.formInline.operationsman_id = '';
                    this.formInline.operationsman_name = '';
                    localStorage.setItem('census', JSON.stringify(this.formInline))
                }
            },
            // 导出
            chooseExport(){
                var formInline = this.formInline
                formInline.pagesize = '0';
                var data='';
                for (const key in formInline) {
                    if(formInline[key]){
                        data+=key+'='+formInline[key]+'&'
                    }
                }
                data=data.slice(0,data.length-1)

                let consturl="https://api.aso.gzjiuyi.net/dailyreport/export?" + data   //下载地址url
                var xhr = new XMLHttpRequest();
                xhr.open("get", consturl, true); // get、post都可
                xhr.responseType = "blob";  
                xhr.setRequestHeader("token",localStorage.getItem('logintoken')); //加请求头
                xhr.onload = function() {
                    if(xhr.status==200){
                        var blob = this.response;
                        var a = document.createElement("a")
                        var url = window.URL.createObjectURL(blob)
                        a.href = url
                        var farmname=consturl.substring(consturl.length-21)
                        a.download = "日报统计.xls"  // 文件名
                    }
                    a.click()
                    window.URL.revokeObjectURL(url)
                } 
                xhr.send();
            },
            // 获取当前日期
            getTime() {
                const date = new Date();
                const Y = date.getFullYear();
                const M = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                this.time = Y + '-' + M + '-' + D;
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>
<style>
    .census .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .census .page-box {
        text-align: right !important;
    }

    .census .el-table__body-wrapper {
        overflow-y: auto !important;
        max-height: calc(100vh - 460px) !important;
    }

    .census .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .census .el-dialog__body::-webkit-scrollbar {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/views/dataReport/census.vue